import React from 'react';
import { i18n } from 'config/locales';
import { Summary, DateSummary } from 'components/Summary';

import { LEGAL, LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW } from 'config/formSections/legal';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import MembershipOverthrowItem from './MembershipOverthrowItem';

const sectionConfig = {
  key: LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW.name,
  storeKey: LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW.storeKey,
};

export class MembershipOverthrow extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateBranch = this.updateBranch.bind(this);
    this.updateList = this.updateList.bind(this);
    this.summary = this.summary.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasOverthrow: this.props.HasOverthrow,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasOverthrow: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const dates = DateSummary(o.Dates);
    const details = (o.Organization || {}).value || '';

    return Summary({
      type: i18n.t('legal.associations.overthrow.collection.item'),
      index,
      left: details,
      right: dates,
      placeholder: i18n.t('legal.associations.overthrow.collection.unknown'),
    });
  };

  render() {
    const { errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    return (
      <div
        className="section-content legal-associations-overthrow"
        data-section={LEGAL.key}
        data-subsection={LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW.key}
      >
        <h1 className="section-header">{i18n.t('legal.subsection.associations.overthrow')}</h1>
        <Branch
          attribute="HasOverthrow"
          name="has_overthrow"
          label={i18n.t('legal.associations.overthrow.heading.title')}
          labelSize="h4"
          className="legal-associations-overthrow-has-overthrow"
          {...this.props.HasOverthrow}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateBranch} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
        />

        <Show when={this.props.HasOverthrow.value === 'Yes'}>
          <Accordion
            attribute="List"
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            errors={accordionErrors}
            summary={this.summary} // eslint-disable-line @typescript-eslint/unbound-method
            onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            description={i18n.t('legal.associations.overthrow.collection.description')}
            appendTitle={i18n.t('legal.associations.overthrow.collection.appendTitle')}
            appendLabel={i18n.t('legal.associations.overthrow.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          >
            <MembershipOverthrowItem
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

MembershipOverthrow.defaultProps = {
  name: 'overthrow',
  HasOverthrow: {},
  List: EmptyListInstance,
  defaultState: true,
  onUpdate: () => {},
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'associations/membership-overthrow',
  addressBooks: {},
  dispatch: () => {},
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(MembershipOverthrow, sectionConfig);
